import React from 'react';
import { Form, Input, DatePicker, Select, Button, Tabs } from 'antd';
import { FormInstance } from 'antd/es/form';
import {
  Platform,
  OrderStatus,
  SubscriptionSearchParams,
  AndroidSubscriptionNotificationTypeLabelMap,
  AppleSubscriptionNotificationTypeLabelMap,
} from '../types';

const { RangePicker } = DatePicker;

interface SearchFormProps {
  form: FormInstance<SubscriptionSearchParams>;
  platform: Platform;
  onPlatformChange: (platform: Platform) => void;
  onSearch: () => void;
  onReset: () => void;
}

const SearchForm: React.FC<SearchFormProps> = ({
  form,
  platform,
  onPlatformChange,
  onSearch,
  onReset,
}) => {
  const androidNotificationTypeOptions = React.useMemo(
    () =>
      Object.entries(AndroidSubscriptionNotificationTypeLabelMap).map(([value, label]) => ({
        value: Number(value),
        label,
      })),
    []
  );

  const appleNotificationTypeOptions = React.useMemo(
    () =>
      Object.entries(AppleSubscriptionNotificationTypeLabelMap).map(([value, label]) => ({
        value,
        label,
      })),
    []
  );

  return (
    <div style={{ marginBottom: 16 }}>
      <Tabs
        activeKey={platform}
        onChange={(key) => onPlatformChange(key as Platform)}
        items={[
          { key: Platform.APPLE, label: '苹果' },
          { key: Platform.ANDROID, label: '安卓' },
        ]}
      />

      <Form
        form={form}
        layout="inline"
        onFinish={onSearch}
        initialValues={{ orderStatus: OrderStatus.ACTIVE }}
        style={{ flexWrap: 'wrap', rowGap: 12 }}
      >
        <Form.Item name="suppId"
          style={{ width: 140 }}
        >
          <Input placeholder="请输入Supp ID" allowClear />
        </Form.Item>

        <Form.Item name="transactionId"
          style={{ width: 130 }}
        >
          <Input placeholder="请输入交易ID" allowClear />
        </Form.Item>

        <Form.Item name="dateRange">
          <RangePicker
            style={{ width: '100%' }}
            placeholder={['订阅生效时间', '订阅生效时间']}
            format="YYYY-MM-DD"
          />
        </Form.Item>

        <Form.Item name="env">
          <Select
            placeholder="请选择订单环境"
            allowClear
            style={{ width: 140 }}
            options={[
              { label: '正式', value: 1 },
              { label: '测试', value: 0 },
            ]}
          />
        </Form.Item>

        <Form.Item name="orderStatus" 
         style={{ width: 140 }}
        >
          <Select
            placeholder="请选择会员状态"
            // allowClear
            options={[
              { label: '有效', value: OrderStatus.ACTIVE },
              { label: '过期', value: OrderStatus.EXPIRED },
              { label: '撤销', value: OrderStatus.CANCELLED },
            ]}
          />
        </Form.Item>

        <Form.Item name="renewalStatus">
          <Select
            placeholder="请选择是否续订"
            allowClear
            options={[
              { label: '是', value: 1 },
              { label: '否', value: 0 },
            ]}
          />
        </Form.Item>

        <Form.Item name="notificationType">
          <Select
            placeholder="请选择通知类型"
            allowClear
            style={{ width: 260 }}
            options={
              platform === Platform.ANDROID
                ? androidNotificationTypeOptions
                : appleNotificationTypeOptions
            }
            showSearch
            optionFilterProp="label"
          />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit">
            搜索
          </Button>
          <Button style={{ marginLeft: 8 }} onClick={onReset}>
            重置
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default SearchForm;
